export default "/_next/static/images/dffa040d9e1534e0ffa712cdd35cd281.png";